import PropTypes from "prop-types";
import Decorator from "clientDecorator";
import ProfileCardHeader from "apps/profile/components/profile-card-header.js";
import EmptyStateMessage from "components/lists/empty-state-message";
import { ModalTrigger2, LinkButton, Icon } from "@evertrue/et-components";
import InterestEnrichmentModal from "./interest-enrichment-modal";
import EnrichmentList from "../enrichment-list";

const PROBABLY_DISPLAY_LIMIT = 12;

const ACCESSOR = "interest_name";

const renderTitle = (group) => {
  switch (group) {
    case "higher":
      return <div className="profile-enrichment--accent">Higher affinity with...</div>;
    case "moderate":
      return <div className="profile-enrichment--accent-light">Moderate affinity with...</div>;
    default:
      break;
  }
};

//Render method for list in cards, most likely a subset
const renderInterests = (rankedInterests) => (
  <div>
    {rankedInterests.probably.length ? (
      <EnrichmentList
        title={renderTitle("higher")}
        list={rankedInterests.probably}
        limit={PROBABLY_DISPLAY_LIMIT}
        accessor={ACCESSOR}
      />
    ) : null}
    {rankedInterests.might.length ? (
      <div className="profile-enrichment-interest-group">
        {renderTitle("moderate")}
        <ModalTrigger2
          closeOnOutsideClick
          trigger={({ open }) => {
            return (
              <LinkButton
                className="profile-enrichment--view"
                title={`View ${rankedInterests.might.length} more interests`}
                onClick={open}
              >
                {`${rankedInterests.might.length} Interests`}
              </LinkButton>
            );
          }}
        >
          {({ close }) => {
            return (
              <InterestEnrichmentModal close={close}>
                <div className="profile-enrichment--lists">
                  <EnrichmentList
                    title={renderTitle("moderate")}
                    list={rankedInterests.might}
                    limit={rankedInterests.might.length}
                    accessor={ACCESSOR}
                  />
                </div>
              </InterestEnrichmentModal>
            );
          }}
        </ModalTrigger2>
      </div>
    ) : null}
    {rankedInterests.additional.length ? (
      <div className="profile-enrichment-interest-group">
        <div>Additional affinity...</div>
        <ModalTrigger2
          closeOnOutsideClick
          trigger={({ open }) => {
            return (
              <LinkButton
                className="profile-enrichment--more"
                title={`View ${rankedInterests.additional.length} more interests`}
                onClick={open}
              >
                {`${rankedInterests.additional.length} Interests`}
              </LinkButton>
            );
          }}
        >
          {({ close }) => {
            return (
              <InterestEnrichmentModal close={close}>
                <div className="profile-enrichment--lists">
                  <EnrichmentList
                    title="Additional affinity..."
                    list={rankedInterests.additional}
                    limit={rankedInterests.additional.length}
                    accessor={ACCESSOR}
                  />
                </div>
              </InterestEnrichmentModal>
            );
          }}
        </ModalTrigger2>
      </div>
    ) : null}
  </div>
);

//Render method for View All trigger and modal, which shows all interests, grouped correctly
const renderViewAll = (rankedInterests) => (
  <ModalTrigger2
    closeOnOutsideClick
    trigger={({ open }) => {
      return (
        <LinkButton className="profile-enrichment--view-all" title={`View all interests`} onClick={open}>
          View All
        </LinkButton>
      );
    }}
  >
    {({ close }) => {
      return (
        <InterestEnrichmentModal close={close}>
          <EnrichmentList
            title={renderTitle("higher")}
            list={rankedInterests.probably}
            limit={rankedInterests.probably.length}
            accessor={ACCESSOR}
          />
          <EnrichmentList
            title={renderTitle("moderate")}
            list={rankedInterests.might}
            limit={rankedInterests.might.length}
            accessor={ACCESSOR}
          />
          <EnrichmentList
            title={<div>Additional affinity...</div>}
            list={rankedInterests.additional}
            limit={rankedInterests.additional.length}
            accessor={ACCESSOR}
          />
        </InterestEnrichmentModal>
      );
    }}
  </ModalTrigger2>
);

const InterestsEnrichment = ({ interests = [] }) => {
  const rankedInterests = Decorator.Enrichment.getRankedInterests(interests);

  return (
    <>
      <ProfileCardHeader title="Personal Interests">
        <span className="profile-enrichment--match">Machine-matched</span>
        <Icon icon="gauge" className="profile-enrichment--icon" />
      </ProfileCardHeader>
      <div className="profile--enrichment-inner">
        {interests.length ? renderViewAll(rankedInterests) : null}
        {interests.length ? (
          renderInterests(rankedInterests)
        ) : (
          <EmptyStateMessage hideIcon text="No enriched interest data available" />
        )}
      </div>
    </>
  );
};

InterestsEnrichment.propTypes = {
  interests: PropTypes.array,
};

export default InterestsEnrichment;
